import React, { useState } from 'react';
import { OverflowMenu } from 'ui/actionMenu';
import { ActionMenuOption } from 'ui/actionMenu/types';
import { BUTTON_SIZES, GhostButton } from 'ui/button';
import {
  ARROW_DIRECTION_DOWN,
  ARROW_DIRECTION_UP,
  CollapsibleContentArrow,
} from 'ui/collapsibleContent';
import { Tag } from 'ui/tags';
import {
  Actions,
  BodyHeading,
  CardBody,
  CardHeader,
  CardWrapper,
  Details,
  Heading,
  Metadata,
} from './CollapsibleContentCard.styled';

type Props = {
  customCardAction?: React.ReactNode;
  cardOverflowOptions?: ActionMenuOption[];
  children?: any;
  contentHeading?: string;
  hasChildren?: boolean; // ie. messageTypes.length > 0
  id: string;
  metadata: string | React.ReactNode; // string or string with Tooltip
  tagText?: string;
  title: string | React.ReactNode;
  toggleLabel?: string;
};

export const CollapsibleContentCard = ({
  cardOverflowOptions,
  children,
  contentHeading,
  customCardAction,
  hasChildren,
  id,
  metadata,
  tagText,
  title,
  toggleLabel = 'Toggle',
}: Props) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const handleToggle = () => setIsExpanded(!isExpanded);
  return (
    <CardWrapper id={id} data-test={`content-card`}>
      <CardHeader data-test="content-card-header">
        <Details>
          <Heading>
            {title}
            {tagText && <Tag text={tagText} />}
          </Heading>
          <Metadata>{metadata}</Metadata>
        </Details>
        <Actions>
          {hasChildren ? (
            <GhostButton
              data-test="content-card-toggle"
              onClick={handleToggle}
              size={BUTTON_SIZES.SMALL}
            >
              <span>{toggleLabel}</span>
              <CollapsibleContentArrow
                isCollapsed={!isExpanded}
                arrowStart={ARROW_DIRECTION_DOWN}
                arrowEnd={ARROW_DIRECTION_UP}
                width={16}
                height={16}
              />
            </GhostButton>
          ) : (
            customCardAction
          )}
          {cardOverflowOptions && (
            <OverflowMenu
              id={`channel-${id}-options`}
              data-test="content-card-options"
              options={cardOverflowOptions}
              size={BUTTON_SIZES.LARGE}
            />
          )}
        </Actions>
      </CardHeader>
      {hasChildren && (
        <CardBody data-test="content-card-body" isCollapsed={!isExpanded}>
          {contentHeading && <BodyHeading>{contentHeading}</BodyHeading>}
          {children}
        </CardBody>
      )}
    </CardWrapper>
  );
};
